import React, { useState } from "react";

const NewVisaForm = ({ onSubmit }) => {

  const visaTypes = ["Tourist", "Business", "Student", "Work", "Transit", "Medical"];
  const countries = ["United States", "Canada", "United Kingdom", "Australia", "India", "Germany", "France"];
  const purposes = ["Vacation", "Work Assignment", "Education", "Medical Treatment", "Conference", "Family Visit"];

  const [formData, setFormData] = useState({
    visaType: "",
    country: "",
    entryType: "",
    duration: "",
    purpose: "",
    passportNumber: "",
    issueDate: "",
    expiryDate: "",
    additionalDocs: null,
  });

  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "file" ? files[0] : value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  return (
    <div className="bg-gray-800 text-white shadow-lg rounded-xl p-6 mt-6 w-full">
      <h2 className="text-2xl font-bold text-center text-yellow-400 mb-6">New Visa Application</h2>

      <form className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 gap-4" onSubmit={handleSubmit}>
        {[
          { label: "Visa Type", name: "visaType", type: "select", options: visaTypes },
          { label: "Country", name: "country", type: "select", options: countries },
          { label: "Entry Type", name: "entryType", type: "text" },
          { label: "Visa Duration", name: "duration", type: "text" },
          { label: "Passport Number", name: "passportNumber", type: "text" },
          { label: "Issue Date", name: "issueDate", type: "date" },
          { label: "Expiry Date", name: "expiryDate", type: "date" },
          { label: "Purpose", name: "purpose", type: "select", options: purposes },
        ].map(({ label, name, type, options }) => (
          <div key={name} className="w-full">
            <label className="block text-gray-300 font-medium mb-1">{label}</label>
            
            {type === "select" ? (
              <select
                name={name}
                value={formData[name] || ""}
                onChange={handleChange}
                required
                className="h-10 w-full border rounded-md p-2 bg-gray-700 text-white focus:ring focus:ring-blue-400 outline-none"
              >
                <option value="">Select {label}</option>
                {options.map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>
            ) : (
              <input
                type={type}
                name={name}
                value={formData[name] || ""}
                onChange={handleChange}
                required
                className="w-full border rounded-md p-2 bg-gray-700 text-white focus:ring focus:ring-blue-400 outline-none"
              />
            )}
          </div>
        ))}

        {/* <div className="col-span-1 md:col-span-2">
          <label className="block text-gray-300 font-medium mb-1">Purpose of Visit</label>
          <textarea
            name="purpose"
            value={formData.purpose}
            onChange={handleChange}
            required
            className="w-full border rounded-md p-2 bg-gray-700 text-white focus:ring focus:ring-blue-400 outline-none"
          />
        </div> */}

        <div className="col-span-1 md:col-span-2">
          <label className="block text-gray-300 font-medium mb-1">Additional Documents</label>
          <input
            type="file"
            name="additionalDocs"
            onChange={handleChange}
            accept="image/*,application/pdf"
            className="w-full border rounded-md p-2 bg-gray-700 text-white focus:ring focus:ring-blue-400 outline-none"
          />
        </div>

        <div className="col-span-1 md:col-span-2 flex justify-center mt-4">
          <button
            type="submit"
            className="bg-blue-500 text-white px-6 py-2 rounded-lg hover:bg-blue-600 transition-all"
          >
            Submit Application
          </button>
        </div>
      </form>
    </div>
  );
};

export default NewVisaForm;
